export function getRandomString() {
  const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array(50)
    .fill(0)
    .map(() => c.charAt(Math.floor(Math.random() * c.length)))
    .join('');
}
